  <div class="w-full">
    <div class="flex items-center h-full">
      <p-breadcrumb class="max-w-full" [model]="breadcrumbItems()" [home]="home()" [dt]="breadcrumbStyle"></p-breadcrumb>
    </div>
  </div>
